module.exports = __webpack_public_path__ + "static/media/Webinar.60c72927.svg";